/**
 * Beacon API Service Layer
 *
 * Single source of truth for all API calls.
 * All endpoints call the real API via httpUtil.
 */
import { fetchAsync } from '../utils/httpUtil';
import { FetchPaymentsResponse } from '../store/slices/payment/paymentState';
import { FetchExecutionsResponse } from '../store/slices/execution/executionState';
import { FetchFilesResponse } from '../store/slices/file/fileState';

export const beaconApi = {
  /**
   * POST /payments/fetch
   * Fetches 1–100 payments by their IDs.
   */
  fetchPayments: async (paymentIds: string[], apiBase: string): Promise<FetchPaymentsResponse> => {
    return fetchAsync(`${apiBase}/payments/fetch`, 'POST', JSON.stringify({ paymentIds }));
  },

  /**
   * POST /executions/fetch
   * Fetches 1–100 executions by their IDs.
   */
  fetchExecutions: async (executionIds: string[], apiBase: string): Promise<FetchExecutionsResponse> => {
    return fetchAsync(`${apiBase}/executions/fetch`, 'POST', JSON.stringify({ executionIds }));
  },

  /**
   * POST /files/fetch
   * Fetches one page of executions matching 1–100 file names.
   */
  fetchFiles: async (
    fileNames: string[],
    pageNumber: number,
    pageSize: number,
    apiBase: string,
  ): Promise<FetchFilesResponse> => {
    return fetchAsync(`${apiBase}/files/fetch`, 'POST', JSON.stringify({ fileNames, pageNumber, pageSize }));
  },
};
